module.exports = __webpack_public_path__ + "img/e_2_3_r.e5a42dc2.png";